import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

import store from "../store";
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => {
    err;
  });
};
import storage from "@/utils/customLocalStorage";
import auth from "@/utils/auth";
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/case",
    name: "Case",
    component: () => import("../views/Case.vue"),
  },
  {
    path: "/casedetail",
    name: "CaseDetail",
    component: () => import("../views/CaseDetail.vue"),
  },
  {
    path: "/memberintroduce",
    name: "MemberIntroduce",
    component: () => import("../views/MemberIntroduce.vue"),
  },
  {
    path: "/operaterule",
    name: "OperateRule",
    component: () => import("../views/OperateRule.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/resetpwd",
    name: "ResetPwd",
    component: () => import("../views/ResetPwd.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/registerUpline",
    name: "RegisterUpline",
    component: () => import("../views/RegisterUpline.vue"),
  },
  {
    path: "/complateInfo",
    name: "ComplateInfo",
    component: () => import("../views/ComplateInfo.vue"),
  },
  {
    path: "/center",
    name: "Center",
    component: () => import("../views/Center.vue"),
    redirect: "/accountCenter",
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: "/accountcenter",
        name: "AccountCenter",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/AccountCenter.vue"),
      },
      {
        path: "/projectmanage",
        name: "ProjectManage",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/ProjectManage.vue"),
      },
      {
        path: "/projectmanagedetail",
        name: "ProjectManageDetail",
        component: () => import("../views/center/ProjectManageDetail.vue"),
      },

      {
        path: "/BUGlist",
        name: "BUGList",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/BUGList.vue"),
      },
      {
        path: "/BUGDetail",
        name: "BUGDetail",
        component: () => import("../views/center/BUGDetail.vue"),
      },
      {
        path: "/MyBUGList",
        name: "MyBUGList",
        component: () => import("../views/center/MyBUGList.vue"),
      },
      {
        path: "/myOrderCenter",
        name: "MyOrderCenter",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyOrderCenter.vue"),
      },
      {
        path: "/orderCenter",
        name: "OrderCenter",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/OrderCenter.vue"),
      },
      {
        path: "/mywallet",
        name: "MyWallet",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyWallet.vue"),
      },
      {
        path: "/withdrawal",
        name: "WithDrawal",
        component: () => import("../views/center/WithDrawal.vue"),
      },
      ,
      {
        path: "/resourcecenter",
        name: "ResourceCenter",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/ResourceCenter.vue"),
      },
      {
        path: "/myapply",
        name: "MyApply",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyApply.vue"),
      },
      {
        path: "/mydemand",
        name: "MyDemand",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyDemand.vue"),
      },
      {
        path: "/mydemanddetail",
        name: "MyDemandDetail",
        component: () => import("../views/center/MyDemandDetail.vue"),
      },
      {
        path: "/mycollect",
        name: "MyCollect",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyCollect.vue"),
      },
      {
        path: "/mybasics",
        name: "MyBasics",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyBasics.vue"),
      },
      {
        path: "/myBasicsEdit",
        name: "MyBasicsEdit",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyBasicsEdit.vue"),
      },
      {
        path: "/myaccount",
        name: "MyAccount",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/MyAccount.vue"),
      },
      {
        path: "/beSupplier",
        name: "BeSupplier",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/BeSupplier.vue"),
      },
      {
        path: "/taskCenter",
        name: "TaskCenter",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/TaskCenter.vue"),
      },
      {
        path: "/taskCenterDetail",
        name: "TaskCenterDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/TaskCenterDetail.vue"),
      },
      {
        path: "/publicityCenterDetail",
        name: "PublicityCenterDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/PublicityCenterDetail.vue"),
      },
      {
        path: "/demandCollectDetail",
        name: "DemandCollectDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/DemandCollectDetail.vue"),
      },
      {
        path: "/UIDemandDetail",
        name: "UIDemandDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/UIDemandDetail.vue"),
      },
      {
        path: "/testDemandDetail",
        name: "TestDemandDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/TestDemandDetail.vue"),
      },
      {
        path: "/needsCenter",
        name: "NeedsCenter",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/NeedsCenter.vue"),
      },
      {
        path: "/needsCenterDetail",
        name: "NeedsCenterDetail",
        meta: {
          requireAuth: true,
        },
        component: () => import("../views/center/NeedsCenterDetail.vue"),
      }
    ],
  },
];

const router = new VueRouter({
  routes,
});
// 设置路由守卫，在进页面之前，判断有token，才进入页面，否则返回登录页面
let token = auth.getToken();
token = "1111111111111";
if (token) {
  store.dispatch("acToken", token);
}
router.beforeEach((to, from, next) => {
  // 判断要去的路由有没有requiresAuth
  if (to.matched.some((r) => r.meta.requireAuth)) {
    if (store.state.token) {
      next(); //有token,进行request请求，后台还会验证token
    } else {
      next({
        path: "/login",
      });
    }
  } else {
    next();
  }
});

export default router;
